export interface AppUser {
  id: string;
  email: string;
  name: string;
  picture?: string | null;
  role: string;
  role_label?: string;
  permissions?: string[];
  org_id?: string;
  org_name?: string;
  is_beta_tester?: boolean;
  auth_provider?: string;
  has_access?: boolean;
  plan_status?: string;
  days_left?: number;
  subscription_status?: string;
  current_period_end?: string | null;
}

export const isAdminUser = (user?: AppUser | null): boolean =>
  !!user && (user.permissions?.includes("*") || ["owner", "admin"].includes(user.role));

export const canUser = (user: AppUser | null | undefined, perm: string): boolean => {
  if (!user) return false;
  const perms = user.permissions || [];
  return perms.includes("*") || perms.includes(perm);
};
